import { createContext, useEffect, useRef, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router";
import { Container } from "../../../../common/components/container/Container";
import style from "./style.module.scss";
import "./style.scss";
import { TeamOrderForm } from "./teamOrder/TeamOrderForm";
import { ManifestoForm } from "./manifesto/ManifestoForm";
// import { PlanningForm } from "./planning/PlanningForm";
import { GoBack } from "../../../../common/components/GoBack/GoBack";
import { Loader } from "../../../../common/components/Loader/Loader";
import { FormatDate } from "../../../../utilities/formatDate";
import { HttpStatusCode } from "axios";
import { CommercialOperation } from "../../core/_request";
import { PointingForm } from "./pointing/PointingForm";
import { ContraryReserve } from "./conntraryReserve/ContraryReserve";
import { OverTimeWork } from "./overtimeWork/OverTimeWork";
import { TimesheetOperations } from "./timesheet/TimesheetOPerations";
import { ExecutionReport } from "./executionReport/ExecutionReport";
import { WorkCalendarConstant } from "../../../settings/work_calendar/core/_constant";
import { WorkCalendarService } from "../../../settings/work_calendar/core/_request";
import { Shifting } from "./shifting/Shifting";
import { PlanningMainPage } from "./planning/PlanningMainPage";
import { OperationType, OperationTypeContext } from "../../core/_context";
import { ConfrontationPage } from "./confrontation/ConfrontationPage";
import dayjs from "dayjs";
import { TbListDetails } from "react-icons/tb";
import { CiMedicalClipboard } from "react-icons/ci";
import CustomModal from "../../../../common/components/Modal/CustomModal";
import { Checkbox, Form, Input, Modal } from "antd";
import { SimpleInput } from "../../../../common/components/simpleInput/SimpleInput";
import { InputSelect } from "../../../../common/components/InputSelect/InputSelect";
import { RiDeleteBin5Line } from "react-icons/ri";
import { IoIosAdd } from "react-icons/io";
import TextArea from "antd/es/input/TextArea";
import { CustomButton } from "../../../../common/components/CustomButton/CustomButton";
import Spinner from "../../../../common/components/Spinner/Spinner";
import { FormProvider } from "../../../../common/provider/form/Form.provider";
import { UploadInputFile } from "../../../../common/components/Upload/UploadInputFile";
import { API_BASE_URL } from "../../../../utilities/API_CONSTANT";
import { AiOutlineCloudDownload } from "react-icons/ai";
import { createFormData } from "../../../../utilities/formData";
import { handleNumericDecimalChange, handleNumericDecimalInput } from "../../../../common/utils/numericInputHandler";
import { IoCheckmarkDoneCircleSharp } from "react-icons/io5";

type TabsItemType = {
  key: string;
  title: string;
  component: React.ReactNode;
};
interface OperationContextType {
  initialValue: any;
  handleSetOperationDefaultData: (data: any) => void;
  defaultWorkTimes: any[];
  refreshData: () => void;
  filter: any;
  setFilter: (e: any) => void;
}

const TABS_ITEM: TabsItemType[] = [
  { key: "team-order", title: "Commande Equipe", component: <TeamOrderForm /> },
  { key: "manifeste", title: "Manifeste", component: <ManifestoForm /> },
  { key: "planning", title: "Planification", component: <PlanningMainPage /> }, // { key: "planning", title: "Planification", component: <PlanningForm /> },
  { key: "pointing", title: "Pointage", component: <PointingForm /> },
  /* {
    key: "contradictory-reserve",
    title: "Réserve Contradictoire",
    component: <ContraryReserve />,
  }, */
  {
    key: "performance-report",
    title: "Rapport d'Exécution à Quai",
    component: <ExecutionReport />,
  },
  {
    key: "overtime",
    title: "Travaux Hors Cloche",
    component: <OverTimeWork />,
  },
  { key: "timesheet", title: "Timesheet", component: <TimesheetOperations /> },
  // { key: "details", title: "Détails", component: <OperationDetails /> },
  {
    key: "shifting",
    title: "Shifting & temps d'attente",
    component: <Shifting />,
  },
  {
    key: "confrontation",
    title: "Confrontations",
    component: <ConfrontationPage />,
  },
];

export const OperationContext = createContext<OperationContextType>({} as any);

export const CreateOperation = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  /* const location = useLocation(); */

  const [checked, setChecked] = useState<boolean>(false); 

  const onHandleChecked = () => {
    setChecked((prev: any) => !prev);
  }

  /**
   * CONTEXT FOR PATH
   */

  const location = useLocation();

  const getOperationTypeFromPath = (path: string): OperationType => {
    if (path.includes("/sales-operations")) return "sales";
    if (path.includes("/cabotage")) return "cabotage";
    return "unknown";
  };

  const operationType = getOperationTypeFromPath(location.pathname);

  const searchParams = new URLSearchParams(location.search);
  const initialTab = searchParams.get("tab") || TABS_ITEM[0].key;

  const [title, setTitle] = useState<string>("");
  const [activeTab, setActiveTab] = useState<string>(initialTab);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingOperation, setIsLoadingOperation] = useState<boolean>(false);
  const [initialValue, setInitialValue] = useState<any>();
  const [times, setTimes] = useState<Array<any>>([
    FormatDate.DEFAULT_START_TIME,
    FormatDate.DEFAULT_END_TIME,
  ]);
  const [filter, setFilter] = useState<any>({
    teamsCreatedAt: dayjs().format("YYYY-MM-DD"),
  });

  const [showAddEmbarkationButton, setShowAddEmbarkationButton] = useState<boolean>();
  const [showAddFilesButton, setShowAddFilesButton] = useState<boolean>();
  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>();
  const [openSuccessModal, setOpenSuccessModal] = useState(false);

  const [isOpenModal, setIsOpenModal] = useState(false);

  const handleShowModal = () => {
    setIsOpenModal((prev: boolean) => !prev);
  }

  const [mscChecked, setMscChecked] = useState(false);

  const [isDebarkation, setIsDebarkation] = useState<boolean>(false);
  const [isEmbarkation, setIsEmbarkation] = useState<boolean>(false);
  const [isBoth, setIsBoth] = useState<boolean>(false);


  /**CONTENT FOR WHEN ADDING MANUAL FORM */

  const [sectionErrors, setSectionErrors] = useState<{
      embarkation?: boolean;
      debarkation?: boolean;
    }>({});

    const buildLoads = (data: any) => {
      const containerLoads = (data.containers || []).map((c: any) => ({
        "@type": "ContainerLoad",
        reference: c.reference,
        loadFillingStatus: c.loadFillingStatus?.value,
        sealNumber: c.sealNumber,
        containerType: c.containerType?.value,
        tonnage: c.tonnage,
      }));
    
      const otherLoads = (data.others || []).map((o: any) => ({
        "@type": "OtherLoad",
        label: o.label,
        description: o.description,
        quantity: o.quantity,
        unit: o.unit,
      }));
    
      return [...containerLoads, ...otherLoads];
    };

    const [form] = Form.useForm();

const handleSubmitManifest = async (values: any) => {
  try {
    setIsLoadingSubmit(true);

    const dataToPost: any = {
      id: id,
    };

    if ((isDebarkation || isBoth) && values.debarkation) {
      dataToPost.debarkationMovement = {
        loads: buildLoads(values.debarkation || {}),
      };
    }

    if ((isEmbarkation || isBoth) && values.embarkation) {
      dataToPost.embarkationMovement = {
        loads: buildLoads(values.embarkation || {}),
      };
    }

    const res = await CommercialOperation.updateOperations(dataToPost);

    if (res?.status === HttpStatusCode.Ok) {
      setShowAddFilesButton(false);
      setIsOpenModal(false);
      refreshData();
    }

  } catch (e) {
    console.log(e);
  } finally {
    setIsLoadingSubmit(false);
  }
};

    const OperationBlock = ({
      title,
      prefix,
    }: {
      title: string;
      prefix: "embarkation" | "debarkation";
    }) => {
      const form = Form.useFormInstance();
    
      const [containers, setContainers] = useState<any[]>([]);
      const [others, setOthers] = useState<any[]>([]);
      const [selectedLoadFillingStatus, setSelectedLoadFillingStatus] = useState<{
        [key: number]: string;
      }>({});
    
      const addContainer = () => {
        setContainers((prev) => [...prev, {}]);
      };
    
      const removeContainer = (index: number) => {
        const current = form.getFieldValue(prefix)?.containers || [];
    
        const updated = current.filter((_: any, i: number) => i !== index);
    
        form.setFieldsValue({
          [prefix]: {
            ...form.getFieldValue(prefix),
            containers: updated,
          },
        });
    
        setContainers(updated);
      };
    
      const addOther = () => {
        setOthers((prev) => [...prev, {}]);
      };
    
      const removeOther = (index: number) => {
        const current = form.getFieldValue(prefix)?.others || [];
    
        const updated = current.filter((_: any, i: number) => i !== index);
    
        form.setFieldsValue({
          [prefix]: {
            ...form.getFieldValue(prefix),
            others: updated,
          },
        });
    
        setOthers(updated);
      };
    
      return (
        <>
          <div className={style.basic__movement_container}>
            <p className={style.basic__title}>{title}</p>
    
            {/* CONTENEURS */}
            <span>Conteneurs</span>
            <br />
    
            {containers.map((_, index) => {
              const filled =
                selectedLoadFillingStatus[index] ===
                "/api/load_filling_statuses/FILLED";
    
              return (
                <div key={index}>
                  <div className={style.basic__form_first_content}>
                    <div className={style.basic__form_first_content_item}>
                      <SimpleInput
                        Form={Form}
                        name={[prefix, "containers", index, "reference"]}
                        label="Référence"
                        rules={[{ required: true }]}
                        customInput={<Input />}
                      />
                    </div>
    
                    <div className={style.basic__form_first_content_item}>
                      <SimpleInput
                        Form={Form}
                        name={[prefix, "containers", index, "loadFillingStatus"]}
                        label="Etat"
                        rules={[{ required: true }]}
                        customInput={
                          <InputSelect
                            uri="/api/load_filling_status/select"
                            onChange={(e) => {
                              setSelectedLoadFillingStatus((prev) => ({
                                ...prev,
                                [index]: e?.value,
                              }));
                            }}
                          />
                        }
                      />
                    </div>
    
                    {filled && (
                      <div className={style.basic__form_first_content_item}>
                        <SimpleInput
                          Form={Form}
                          name={[prefix, "containers", index, "sealNumber"]}
                          label="N° Plomb"
                          rules={[{ required: true }]}
                          customInput={<Input />}
                        />
                      </div>
                    )}
    
                    <div className={style.basic__form_first_content_item}>
                      <SimpleInput
                        Form={Form}
                        name={[prefix, "containers", index, "containerType"]}
                        label="Type"
                        rules={[{ required: true }]}
                        customInput={
                          <InputSelect uri="/api/container_types/select" onChange={() => {}}/>
                        }
                      />
                    </div>
    
                    <div className={style.basic__form_first_content_item}>
                      <SimpleInput
                        Form={Form}
                        name={[prefix, "containers", index, "tonnage"]}
                        label="Tonnage"
                        rules={[{ required: true }]}
                        customInput={
                          <Input
                            onKeyDown={handleNumericDecimalInput}
                            onChange={handleNumericDecimalChange}
                          />
                        }
                      />
                    </div>
    
                    <div className={style.basic__form_first_content_item}>
                      <RiDeleteBin5Line
                        className={style.basic__delete_icon}
                        onClick={() => removeContainer(index)}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
    
            <button
              className={style.basic__add_btn}
              type="button"
              onClick={addContainer}
            >
              <IoIosAdd /> Ajouter
            </button>
    
            <br />
            <br />
    
            {/* AUTRES */}
            <span>Autres</span>
            <br />
    
            {others.map((_, index) => (
              <div key={index}>
                <div className={style.basic__form_first_content}>
                  <div className={style.basic__form_first_content_item}>
                    <SimpleInput
                      Form={Form}
                      name={[prefix, "others", index, "label"]}
                      label="Label"
                      rules={[{ required: true }]}
                      customInput={<Input />}
                    />
                  </div>
    
                  <div className={style.basic__form_first_content_item}>
                    <SimpleInput
                      Form={Form}
                      name={[prefix, "others", index, "quantity"]}
                      label="Quantité"
                      rules={[{ required: true }]}
                      customInput={<Input />}
                    />
                  </div>
    
                  <div className={style.basic__form_first_content_item}>
                    <SimpleInput
                      Form={Form}
                      name={[prefix, "others", index, "unit"]}
                      label="Unité"
                      rules={[{ required: true }]}
                      customInput={<Input />}
                    />
                  </div>

                  <div className={style.basic__form_first_content_item}>
                          <SimpleInput
                            Form={Form}
                            name={[prefix, "others", index, "description"]}
                            label="Description"
                            customInput={<TextArea style={{ height: "20px" }} />}
                          />
                        </div>
    
                  <div className={style.basic__form_first_content_item}>
                    <RiDeleteBin5Line
                      className={style.basic__delete_icon}
                      onClick={() => removeOther(index)}
                    />
                  </div>
                </div>
              </div>
            ))}
    
            <button
              className={style.basic__add_btn}
              type="button"
              onClick={addOther}
            >
              <IoIosAdd /> Ajouter
            </button>
          </div>
        </>
      );
    };
    
    const CabotageManifestoFile = () => {
      const STATIC_FILES_NAME = {
        MANIFESTE: "manifestFile",
      };
    
      const [form] = Form.useForm();
    
      const handleSubmitFile = async (values: any) => {
        try {
          setIsLoading(true);
  
          const dataToPost = {
            operation: id,
    
            // Non MSC
            ...(!checked && {
              [STATIC_FILES_NAME.MANIFESTE]:
                values?.[STATIC_FILES_NAME.MANIFESTE]?.[0]?.originFileObj,
            }),
          };
  
          const res = await CommercialOperation.addManifestoFiles(createFormData(dataToPost));
  
          if (res.status === HttpStatusCode.Ok) {
            setShowAddFilesButton(false);
            setIsOpenModal(false);
            refreshData();
            setOpenSuccessModal(true);

          setTimeout(() => {
            setOpenSuccessModal(false);
          }, 2000);
          }
        } catch (error) {
          console.log(error);
        } finally {
          setIsLoading(false);
        }
      }
    
      return (
        <FormProvider
          Form={Form}
          form={form}
          debug
          onFinish={(values) => {
            handleSubmitFile(values);
          }}
          onFinishFailed={(err) => {
            console.log("err", err);
          }}
        >
          <div className={style.basic__form_first_content}>
            <div className={style.basic__form_first_content_item}>
              <SimpleInput
                Form={Form}
                name={STATIC_FILES_NAME.MANIFESTE}
                label={"Manifeste"}
                rules={[
                  {
                    required: true,
                    message: "Ce champs est obligatoire",
                  },
                ]}
                customInput={
                    <UploadInputFile isExcelOnly />
                }
              />
              <div className={style.basic__link_wrapper}>
                <a
                  href={`${API_BASE_URL}/templates/manifeste.xlsx`} // https://sems.api.livenexx.net/templates/manifeste.xlsx
                  download
                  target="_blank"
                  className={style.basic__link}
                >
                  <AiOutlineCloudDownload className={style.basic__link_icon} />{" "}
                  Télécharger le modèle
                </a>
              </div>
            </div>
            <div className={style.basic__form_first_content_item}></div>
          </div>
          {/* BOUTON */}
          <div className={style.basic__footer}>
            <CustomButton
              backgroundColor="#72A4FC"
              className={style.basic__footer_button}
            >
              {isLoadingSubmit ? <Spinner /> : <span>IMPORTER</span>}
            </CustomButton>
          </div>
        </FormProvider>
      );
    };
    

  /** END OF CONTEND FOR WHEN ADDING MANUAL FORM */

  /* BLOC FOR MODAL CONTENT (operation commerciale) */

  const ManifestoFile = ({
    checked,
    setChecked,
  }: {
    checked: boolean;
    setChecked: React.Dispatch<React.SetStateAction<boolean>>;
  }) => {

    const STATIC_FILES_NAME = {
      MANIFESTE: "manifestFile",
      LANDING: "mscDebarkationFile",
      EMPTY_BOARDING: "mscEmptyEmbarkationFile",
      FULL_BOARDING: "mscFullEmbarkationFile",
    };
    
    const [form] = Form.useForm();

    const onChecked = () => {
      setChecked((prev: boolean) => !prev);
    };

    const handleSubmitFile = async (values: any) => {
      try {
        setIsLoading(true);

        const dataToPost = {
          operation: id,
  
          // Non MSC
          ...(!checked && {
              ...(values?.[STATIC_FILES_NAME.MANIFESTE]?.[0]?.originFileObj && {
                [STATIC_FILES_NAME.MANIFESTE]: values[STATIC_FILES_NAME.MANIFESTE][0].originFileObj,
              }),
          }),
  
          // MSC uniquement
          ...(checked && {
            isMsc: 1,
            ...(values?.[STATIC_FILES_NAME.LANDING]?.[0]?.originFileObj && {
              [STATIC_FILES_NAME.LANDING]:
                values[STATIC_FILES_NAME.LANDING][0].originFileObj,
            }),
  
            ...(values?.[STATIC_FILES_NAME.EMPTY_BOARDING]?.[0]
              ?.originFileObj && {
              [STATIC_FILES_NAME.EMPTY_BOARDING]:
                values[STATIC_FILES_NAME.EMPTY_BOARDING][0].originFileObj,
            }),
  
            ...(values?.[STATIC_FILES_NAME.FULL_BOARDING]?.[0]?.originFileObj && {
              [STATIC_FILES_NAME.FULL_BOARDING]:
                values[STATIC_FILES_NAME.FULL_BOARDING][0].originFileObj,
            }),
          }),
        };

        const res = await CommercialOperation.addManifestoFiles(createFormData(dataToPost));

        if (res.status === HttpStatusCode.Ok) {
          setShowAddFilesButton(false);
          setIsOpenModal(false);
          refreshData();

            setOpenSuccessModal(true);

          setTimeout(() => {
            setOpenSuccessModal(false);
          }, 2000);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    }

    return (
      <FormProvider
                Form={Form}
                form={form}
                debug
                onFinish={(values) => {
                  handleSubmitFile(values);
                }}
                onFinishFailed={(err) => {
                  console.log("err", err);
                }}
              >
      <div className={style.basic__form_first_content}>
              { !checked && (
              <div className={style.basic__form_first_content_item}>
                <SimpleInput
                  Form={Form}
                  name={STATIC_FILES_NAME.MANIFESTE}
                  label={"Résumé commercial"}
                  rules={[
                    {
                      required: true,
                      message: "Ce champs est obligatoire",
                    },
                  ]}
                  customInput={
                      <UploadInputFile isExcelOnly/>
                  }
                />
                <div className={style.basic__link_wrapper}>
                  <a
                    href={`${API_BASE_URL}/templates/resume_commercial.xlsx`}
                    download
                    target="_blank"
                    className={style.basic__link}
                  >
                    <AiOutlineCloudDownload
                      className={style.basic__link_icon}
                    />{" "}
                    Télécharger le modèle
                  </a>
                </div>
              </div>)}
              { checked && (<div className={style.basic__form_first_content_item}>
                
              </div>)}
            </div>
            {/* CHAMPS MSC */}
            
          
            {checked && (
              <div className={style.basic__form_first_content}>
              <div className={style.basic__form_first_content_item}>
                <SimpleInput
                  Form={Form}
                  name={STATIC_FILES_NAME.LANDING}
                  label={"Ficher de débarquement"}
                  customInput={<UploadInputFile isExcelOnly />}
                />
              </div>
              <div className={style.basic__form_first_content_item}>
                <SimpleInput
                  Form={Form}
                  name={STATIC_FILES_NAME.EMPTY_BOARDING}
                  label="Fichier d'embarquement vide"
                  customInput={<UploadInputFile isExcelOnly />}
                />
              </div>
              <div className={style.basic__form_first_content_item}>
                <SimpleInput
                  Form={Form}
                  name={STATIC_FILES_NAME.FULL_BOARDING}
                  label="Fichier d'embarquement plein"
                  customInput={<UploadInputFile isExcelOnly />}
                />
              </div>
            </div>)}
            <Checkbox className={style.msc_text} checked={checked} onChange={(e) => setChecked(e.target.checked)}>Importer des fichiers MSC</Checkbox>
          {/* BOUTON */}
          <div className={style.basic__footer}>
            <CustomButton
              backgroundColor="#72A4FC"
              className={style.basic__footer_button}
            >
              {isLoadingSubmit ? <Spinner /> : <span>Importer</span>}
            </CustomButton>
          </div>
        </FormProvider>
    );
  }

  /* END OF MODAL CONTENT (operation commerciale) */

  /* BLOC FOR MODAL CONTENT (embarquement) */

  const EmbarkationForm = () => {
    const [form] = Form.useForm();

    const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);

    const [sectionErrors, setSectionErrors] = useState<boolean>(false);

    //const [selectedLoadFillingStatus, setSelectedLoadFillingStatus] = useState<string | null>(null);

    //const filled = selectedLoadFillingStatus === "/api/load_filling_statuses/FILLED"

    const buildLoads = (data: any) => {
      const containerLoads = (data.containers || []).map((c: any) => ({
        "@type": "ContainerLoad",
        reference: c.reference,
        loadFillingStatus: c.loadFillingStatus?.value,
        sealNumber: c.sealNumber,
        containerType: c.containerType?.value,
        tonnage: c.tonnage,
      }));
    
      const otherLoads = (data.others || []).map((o: any) => ({
        "@type": "OtherLoad",
        label: o.label,
        description: o.description,
        quantity: o.quantity,
        unit: o.unit,
      }));
    
      return [...containerLoads, ...otherLoads];
    };

    const handleSubmitFile = async (values: any) => {
      try {
        setIsLoadingSubmit(true);
        const dataToPost = {
          id: id,
          embarkationMovement: {
            loads: buildLoads(values)
          }
        }

        const res = await CommercialOperation.updateOperations(dataToPost);

        if (res?.status === HttpStatusCode.Ok) {
          setShowAddEmbarkationButton(false);
          setIsOpenModal(false);
          refreshData();
          
        } 
      } catch (error) {
        console.log(error)
      } finally {
        setIsLoadingSubmit(false)
      }
    }

    return (
      <>
      {sectionErrors && (
          <span style={{ color: "#ff4d4f", marginLeft: "10px" }}>
            Veuillez remplir cette section
          </span>
        )}
        <div className={style.basic__movement_container}>
          {/* CONTENEURS */}
          <span>Conteneurs</span>
          <br />

          <Form 
          form={form} 
          onFinish={(values) => {
            const isNotEmpty =
              (values?.containers && values.containers.length > 0) ||
              (values?.others && values.others.length > 0);
        
            if (!isNotEmpty) {
              setSectionErrors(true);
              return;
            }
        
            setSectionErrors(false);
            handleSubmitFile(values);
          }}
          onFinishFailed={() => {
            setSectionErrors(true);
          }}
          >
            <Form.List name="containers">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => (
                    <div key={key} className={style.basic__form_first_content}>
                      <div className={style.basic__form_first_content_item}>
                        <SimpleInput
                          Form={Form}
                          name={[name, "reference"]}
                          label="Référence"
                          rules={[
                            {
                              required: true,
                              message: "Ce champs est obligatoire",
                            },
                          ]}
                          customInput={<Input />}
                        />
                      </div>
                      <div className={style.basic__form_first_content_item}>
                        <SimpleInput
                          Form={Form}
                          name={[name, "loadFillingStatus"]}
                          label="Etat"
                          rules={[
                            {
                              required: true,
                              message: "Ce champs est obligatoire",
                            },
                          ]}
                          customInput={
                            <InputSelect
                              uri="/api/load_filling_status/select"
                              onChange={(value) => {
                                form.setFieldValue(
                                  ["containers", name, "loadFillingStatus"],
                                  value
                                );
                              }}
                            />
                          }
                        />
                      </div>
                      <Form.Item
  noStyle
  shouldUpdate={(prev, curr) =>
    prev.containers?.[name]?.loadFillingStatus !==
    curr.containers?.[name]?.loadFillingStatus
  }
>
  {() => {
    const field = form.getFieldValue([
      "containers",
      name,
      "loadFillingStatus",
    ]);

    const filled =
      field?.value === "/api/load_filling_statuses/FILLED";

    if (!filled) return null;

    return (
      <div className={style.basic__form_first_content_item}>
        <SimpleInput
          Form={Form}
          name={[name, "sealNumber"]}
          label="N° Plomb"
          rules={[
            {
              required: true,
              message: "Ce champs est obligatoire",
            },
          ]}
          customInput={<Input />}
        />
      </div>
    );
  }}
</Form.Item>

                      <div className={style.basic__form_first_content_item}>
                        <SimpleInput
                          Form={Form}
                          name={[name, "containerType"]}
                          label="Type"
                          rules={[
                            {
                              required: true,
                              message: "Ce champs est obligatoire",
                            },
                          ]}
                          customInput={
                            <InputSelect
                              uri="/api/container_types/select"
                              onChange={() => {}}
                            />
                          }
                        />
                      </div>
                      <div className={style.basic__form_first_content_item}>
                        <SimpleInput
                          Form={Form}
                          name={[name, "tonnage"]}
                          label="Tonnage"
                          rules={[
                            {
                              required: true,
                              message: "Ce champs est obligatoire",
                            },
                          ]}
                          customInput={<Input onKeyDown={handleNumericDecimalInput}/>}
                        />
                      </div>
                      <div className={style.basic__form_first_content_item}>
                        <RiDeleteBin5Line
                          className={style.basic__delete_icon}
                          onClick={() => remove(name)}
                        />
                      </div>
                    </div>
                  ))}

                  <button
                    className={style.basic__add_btn}
                    type="button"
                    onClick={() => add()}
                  >
                    Ajouter
                  </button>
                </>
              )}
            </Form.List>

            <br />
            <br />

            {/* AUTRES */}
            <span>Autres</span>
            <br />
            <Form.List name="others">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name }) => (
                    <div key={key}>
                      <div className={style.basic__form_first_content}>
                        <div className={style.basic__form_first_content_item}>
                          <SimpleInput
                            Form={Form}
                            name={[name, "label"]}
                            label="Label"
                            rules={[
                              {
                                required: true,
                                message: "Ce champs est obligatoire",
                              },
                            ]}
                            customInput={<Input />}
                          />
                        </div>

                        <div
                          className={style.basic__form_first_content_item}
                          style={{ display: "flex", gap: 10 }}
                        >
                          <div style={{ flex: 3 / 5 }}>
                            <SimpleInput
                              Form={Form}
                              name={[name, "quantity"]}
                              label="Quantité"
                              rules={[
                                {
                                  required: true,
                                  message: "Ce champs est obligatoire",
                                },
                              ]}
                              customInput={<Input />}
                            />
                          </div>

                          <div style={{ flex: 2 / 5 }}>
                            <SimpleInput
                              Form={Form}
                              name={[name, "unit"]}
                              label="Unité"
                              rules={[
                                {
                                  required: true,
                                  message: "Ce champs est obligatoire",
                                },
                              ]}
                              customInput={<Input />}
                            />
                          </div>
                        </div>

                        <div className={style.basic__form_first_content_item}>
                          <SimpleInput
                            Form={Form}
                            name={[name, "description"]}
                            label="Description"
                            customInput={<TextArea style={{ height: "20px" }} />}
                          />
                        </div>

                        <div className={style.basic__form_first_content_item}>
                          <RiDeleteBin5Line
                            className={style.basic__delete_icon}
                            onClick={() => remove(name)}
                          />
                        </div>
                      </div>
                    </div>
                  ))}

                  <button
                    className={style.basic__add_btn}
                    type="button"
                    onClick={() => add()}
                  >
                    Ajouter
                  </button>
                </>
              )}
            </Form.List>

            <div className={style.basic__footer}>
              <CustomButton
                backgroundColor="#72A4FC"
                className={style.basic__footer_button}
              >
                {isLoadingSubmit ? <Spinner /> : <span>Ajouter l'embarquement </span>}
              </CustomButton>
            </div>
          </Form>
        </div>
      </>
    );
  };

/* END MODAL CONTENT (embarquement) */

  /**
   * MENU ITEMS STYLE
   */

  ///// INDICATEURS DE SCROLL (gauche/droite) /////

  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const updateScrollIndicators = () => {
    if (!tabWrapperRef.current) return;

    const { scrollLeft, scrollWidth, clientWidth } = tabWrapperRef.current;

    setCanScrollLeft(scrollLeft > 0);
    setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 1);
  };

  useEffect(() => {
    const wrapper = tabWrapperRef.current;
    if (!wrapper) return;

    updateScrollIndicators();
    wrapper.addEventListener("scroll", updateScrollIndicators);

    return () => {
      wrapper.removeEventListener("scroll", updateScrollIndicators);
    };
  }, []);

  ///// LARGEUR ÉGALE POUR TOUS LES ONGLETS /////

  useEffect(() => {
    const items = document.querySelectorAll(`.${style.operation__tab_item}`);
    let maxWidth = 0;

    items.forEach((item) => {
      const width = item.scrollWidth; // largeur réelle du texte
      if (width > maxWidth) maxWidth = width;
    });

    document.documentElement.style.setProperty(
      "--tab-min-width",
      `${maxWidth}px`
    );
  }, []);

  ///// SCROLL FLUIDE ÉLÉMENT PAR ÉLÉMENT /////

  const tabWrapperRef = useRef<HTMLDivElement>(null);
  const scrollIntervalRef = useRef<NodeJS.Timeout | null>(null);

  const scrollOneItem = (direction: "left" | "right") => {
    if (!tabWrapperRef.current) return;

    const container = tabWrapperRef.current;
    const firstItem = container.querySelector(
      `.${style.operation__tab_item}`
    ) as HTMLElement;
    if (!firstItem) return;

    const itemWidth = firstItem.offsetWidth + 10; // including gap

    // Initial position
    const { scrollLeft, scrollWidth, clientWidth } = container;

    // Stop scolling when reaching edge
    if (direction === "left" && scrollLeft <= 0) {
      stopScroll();
      return;
    }
    if (direction === "right" && scrollLeft + clientWidth >= scrollWidth) {
      stopScroll();
      return;
    }

    container.scrollBy({
      left: direction === "left" ? -itemWidth : itemWidth,
      behavior: "smooth",
    });

    // Updtate indicators
    updateScrollIndicators();
  };

  const startScroll = (direction: "left" | "right") => {
    if (scrollIntervalRef.current) clearInterval(scrollIntervalRef.current);

    scrollIntervalRef.current = setInterval(() => {
      scrollOneItem(direction);
    }, 200); // scroll per items each 0.2s
  };

  const stopScroll = () => {
    if (scrollIntervalRef.current) {
      clearInterval(scrollIntervalRef.current);
      scrollIntervalRef.current = null;
    }
  };

  /**
   * END MENU ITEMS STYLE
   */
  useEffect(() => {
    // id && fetchTeamOrder(+id);
    id && filter && getWorkTime(+id, WorkCalendarConstant.WORK_ID, filter);
  }, [id, filter]);

  useEffect(() => {
    setActiveTab(initialTab);
  }, [location.search]);

  const handleChangeActiveTab = (key: string) => {
    navigate(`?tab=${key}`);
  };

  const getWorkTime = async (
    id: number,
    workId: number,
    filterParams?: any
  ) => {
    try {
      setIsLoading(true);

      const res = await WorkCalendarService.getWorkShedule(workId);
      if (res?.status === HttpStatusCode.Ok) {
        setTimes([res?.data?.startTime, res?.data?.endTime]);
        fetchTeamOrder(id, filterParams);
        // form.setFieldsValue(formatedData);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTeamOrder = async (id: number, params?: any) => {
    try {
      setIsLoadingOperation(true);
      const res = await CommercialOperation.getOneOperation(id, params);

      if (res?.status === HttpStatusCode.Ok) {
        setTitle(res?.data?.referenceLabel);

        setInitialValue(
          formatData({
            ...res?.data,
          })
        );

        setShowAddEmbarkationButton(res?.data?.waitingEmbarkation)
        setShowAddFilesButton(res?.data?.operationState.id === "AWAITING_MANIFESTE")
        setIsEmbarkation(res?.data?.operationType?.id === "EMBARKATION")
        setIsDebarkation(res?.data?.operationType?.id === "DEBARKATION")
        setIsBoth(res?.data?.operationType?.id === "EMBARKATION_DEBARKATION")
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingOperation(false);
    }
  };

  const formatData = (data: any) => {
    const formattedData = {
      ...data,
      holdsValueLength: data?.holds?.length,
      receiptRequestAt: data?.receiptRequestAt
        ? FormatDate.dayjsFormat(data?.receiptRequestAt)
        : null,
      estimatedArrivalAt: data?.estimatedArrivalAt
        ? FormatDate.dayjsFormat(data?.estimatedArrivalAt)
        : null,
      startAt: data?.startAt ? FormatDate.dayjsFormat(data?.startAt) : null,
      endAt: data?.endAt ? FormatDate.dayjsFormat(data?.endAt) : null,
      teamOrderFile: data?.teamOrderFile
        ? {
            label: data?.teamOrderFile?.basename,
            value: data?.teamOrderFile?.["@id"],
          }
        : null,
      arrivalNoticeFile: data?.arrivalNoticeFile
        ? {
            label: data?.arrivalNoticeFile?.basename,
            value: data?.arrivalNoticeFile?.["@id"],
          }
        : null,
      embarkationPlanFile: data?.embarkationPlanFile
        ? {
            label: data?.embarkationPlanFile?.basename,
            value: data?.embarkationPlanFile?.["@id"],
          }
        : null,
      debarkationPlanFile: data?.debarkationPlanFile
        ? {
            label: data?.debarkationPlanFile?.basename,
            value: data?.debarkationPlanFile?.["@id"],
          }
        : null,
      customer: data?.customer
        ? {
            label: data?.customer?.name,
            value: data?.customer?.[`@id`],
          }
        : null,
      customerCategory: data?.customer
        ? {
            label: data?.customer?.customerCategory?.name,
            value: data?.customer?.customerCategory?.[`@id`],
          }
        : null,
      operationType: data?.operationType
        ? {
            label: data?.operationType?.name,
            value: data?.operationType?.["@id"],
          }
        : null,
      operationShifting: data?.operationShifting
        ? {
            label: data?.operationShifting?.name,
            value: data?.operationShifting?.["@id"],
          }
        : null,
      teamsDockside: data?.teamsDockside?.map((item: any) => ({
        ...item,
        teamShiftStart: FormatDate.dayjsTimeFormat(
          item?.teamShiftStart ?? "06:00"
        ),
        teamShiftEnd: FormatDate.dayjsTimeFormat(item?.teamShiftEnd ?? "18:00"),
        ...(item?.assignmentLocation
          ? {
              assignmentLocation: {
                label: item?.assignmentLocation?.name,
                value: item?.assignmentLocation?.["@id"],
              },
            }
          : {}),
      })),
      teamsOnBoard: data?.teamsOnBoard?.map((item: any) => ({
        ...item,
        teamShiftStart: FormatDate.dayjsTimeFormat(
          item?.teamShiftStart ?? times[0]
        ),
        teamShiftEnd: FormatDate.dayjsTimeFormat(
          item?.teamShiftEnd ?? times[1]
        ),
      })),
      teamsStorage: data?.teamsStorage?.map((item: any) => ({
        ...item,
        teamShiftStart: FormatDate.dayjsTimeFormat(
          item?.teamShiftStart ?? times[0]
        ),
        teamShiftEnd: FormatDate.dayjsTimeFormat(
          item?.teamShiftEnd ?? times[1]
        ),
      })),
    };

    return formattedData;
  };

  const handleSetOperationDefaultData = (value: any) => {
    fetchTeamOrder(value?.id, filter);
  };

  const refreshData = () => {
    fetchTeamOrder(id as any, filter);
  };

  const onRedirect = () => {
    navigate(`../detail/${id}`)
  }

  return (
    <OperationTypeContext.Provider value={operationType}>
      <OperationContext.Provider
        value={{
          initialValue,
          handleSetOperationDefaultData,
          defaultWorkTimes: times,
          refreshData,
          filter,
          setFilter,
        }}
      >
        <Loader isLoading={isLoading || isLoadingOperation} />
        <div className={style.operation}>
          <GoBack
            uri={
              operationType === "sales"
                ? "/app/operations/sales-operations"
                : "/app/operations/cabotage"
            }
          />
          <div className={style.operation__header_wrapper}>
            <span className={style.operation__header}>{title}</span>
            <div className={style.buttonWrapper}>
            {showAddEmbarkationButton && (
              <div className={style.buttonLike} onClick={handleShowModal} >
                <CiMedicalClipboard size={18}/>
                Ajouter embarquement
              </div>
            )}
            {showAddFilesButton && (
              <div className={style.buttonLike} onClick={handleShowModal} >
                <CiMedicalClipboard size={18}/>
                Importer manifeste
              </div>
            )}
            <div className={style.buttonLike} onClick={onRedirect}>
              <TbListDetails   size={18} />
              Détails
            </div>
          </div>
          </div>
          <div className={style.operation__tab_wrapper_container}>
            {canScrollLeft && (
              <div
                className={`${style.operation__scroll_zone} ${style.operation__scroll_zone_left}`}
                onMouseEnter={() => startScroll("left")}
                onMouseLeave={stopScroll}
              />
            )}
            {canScrollRight && (
              <div
                className={`${style.operation__scroll_zone} ${style.operation__scroll_zone_right}`}
                onMouseEnter={() => startScroll("right")}
                onMouseLeave={stopScroll}
              />
            )}

            <div ref={tabWrapperRef} className={style.operation__tab_wrapper}>
              {TABS_ITEM.map((item: TabsItemType) => (
                <span
                  className={`${style.operation__tab_item} ${
                    activeTab === item.key
                      ? style.operation__tab_item_active
                      : ""
                  }`}
                  key={item.key}
                  onClick={() => handleChangeActiveTab(item.key)}
                >
                  {item.title}
                </span>
              ))}
            </div>
          </div>

          <Container>
            {TABS_ITEM.find((item) => item.key === activeTab)?.component}
          </Container>
        </div>
        <CustomModal
          isOpen= {isOpenModal}
          hanldeCloseModal={handleShowModal}
          title={`${operationType === "sales" ? "Importer manifeste" : showAddFilesButton ? "Ajouter manifeste" : "Ajouter un embarquement"}`}
          width= {operationType === "sales" ? "68%" : "85%"}
        >
          {operationType === "sales" ? (
            <ManifestoFile checked={mscChecked} setChecked={setMscChecked}/>
          )
          : (
            <>
              {showAddFilesButton ? (
                <>
                  <Checkbox className={style.msc_text} checked={checked} onClick={onHandleChecked}>Remplir manuellement</Checkbox>
                  {checked ? (
                    <Form
                      form={form}
                      onFinish={handleSubmitManifest}
                      onFinishFailed={() => console.log("error")}
                    >
                      {(isDebarkation || isBoth) && (
                        <OperationBlock title="Débarquement" prefix="debarkation" />
                      )}

                      {(isEmbarkation || isBoth) && (
                        <OperationBlock title="Embarquement" prefix="embarkation" />
                      )}

                      <div className={style.basic__footer}>
                        <CustomButton
                          type="submit"
                          backgroundColor="#72A4FC"
                          className={style.basic__footer_button}
                        >
                          {isLoadingSubmit ? <Spinner /> : <span>AJOUTER MANIFESTE</span>}
                        </CustomButton>
                      </div>
                    </Form>
                  ) : (
                    <CabotageManifestoFile />
                  )}
                </>
              ) : (
                <EmbarkationForm />
              )}
            </>
          )
          }
        </CustomModal>
        <Modal
          open={openSuccessModal}
          centered
          width={300}
          footer={null}
          closable={false}
          styles={{
            body: { padding: 0 },
            content: { padding: 0 },
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              height: "100%",
              padding: "20px",
              backgroundColor: "#f6fff8",
              borderRadius: "12px",
              border: "1px solid #c3e6cb",
              boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
            }}
          >
            <IoCheckmarkDoneCircleSharp
              size={100}
              style={{
                color: "#28a745",
                marginBottom: "20px",
              }}
            />
            <p
              style={{
                margin: 0,
                fontSize: "1rem",
                fontWeight: "600",
                color: "#155724",
              }}
            >
              Manifeste importé avec succès !
            </p>
          </div>
        </Modal>
      </OperationContext.Provider>
    </OperationTypeContext.Provider>
  );
};
